import { render, staticRenderFns } from "./CtaButtonSideNav.vue?vue&type=template&id=07966aeb&"
import script from "./CtaButtonSideNav.vue?vue&type=script&lang=js&"
export * from "./CtaButtonSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports